import { Input, makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

type Props = {
  phoneNumber: string
  code: string
  setCode: (code: string) => void
  error?: any
  onSubmit: () => void
}

export default function ActivateView(props: Props) {
  const styles = useStyles()

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <View style={styles.card}>
          <Text style={styles.title}>{t('enterTheVerificationCode')} </Text>
          <Text style={[styles.title, styles.phoneNumber]}>
            {props.phoneNumber}
          </Text>
        </View>
        <Text style={styles.label}>{t('whatsTheVerificationCode')}</Text>
        <View style={styles.inputContainer}>
          <Input
            style={styles.textInput}
            placeholderTextColor={styles.textInputPlaceholder.color}
            placeholder={t('verificationCode')}
            value={props.code}
            onChangeText={props.setCode}
            keyboardType="phone-pad"
            onSubmitEditing={props.onSubmit}
          />
        </View>
        {props.error ? (
          <Text style={styles.error}>{props.error.message}</Text>
        ) : null}
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors?.grey5,
  },
  inputContainer: {
    flexDirection: 'row',
    backgroundColor: 'white',
    paddingHorizontal: 10,
    paddingVertical: 15,
    alignItems: 'center',
  },
  textInput: {
    fontSize: 17,
    fontStyle: 'italic',
    color: 'gray',
    paddingHorizontal: 10,
    width: '100%',
  },
  textInputPlaceholder: {
    color: 'lightgray',
  },
  error: {
    margin: 10,
    textAlign: 'center',
    color: theme.colors?.primary,
    fontFamily: font.bold,
    fontSize: 16,
  },
  card: {
    backgroundColor: theme.colors?.white,
    padding: 30,
  },
  title: {
    textAlign: 'center',
    margin: 10,
    fontSize: 18,
    color: theme.colors?.grey1,
  },
  label: {
    margin: 10,
    fontSize: 15,
    color: theme.colors?.grey1,
  },
  buttonContainer: {
    margin: 15,
  },
  phoneNumber: {
    fontStyle: 'italic',
  },
}))
